var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25C1 11.7452 11.7452 1 25 1V1C38.2548 1 49 11.7452 49 25V25C49 38.2548 38.2548 49 25 49V49C11.7452 49 1 38.2548 1 25V25Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.102 23.39L33.162 22.33C33.942 21.55 33.942 20.28 33.162 19.5L31.752 18.09C30.972 17.31 29.702 17.31 28.922 18.09L27.862 19.15L32.102 23.39ZM26.442 20.56L17.392 29.61C17.302 29.7 17.252 29.83 17.252 29.96V33.5C17.252 33.78 17.472 34 17.752 34H21.292C21.422 34 21.552 33.95 21.642 33.85L30.692 24.8L26.442 20.56ZM32.252 30.5C32.252 32.69 29.712 34 27.252 34C26.702 34 26.252 33.55 26.252 33C26.252 32.45 26.702 32 27.252 32C28.792 32 30.252 31.27 30.252 30.5C30.252 30.03 29.772 29.63 29.022 29.3L30.502 27.82C31.572 28.45 32.252 29.29 32.252 30.5ZM17.832 26.35C16.862 25.79 16.252 25.06 16.252 24C16.252 22.2 18.142 21.37 19.812 20.64C20.842 20.18 22.252 19.56 22.252 19C22.252 18.59 21.472 18 20.252 18C18.992 18 18.452 18.61 18.422 18.64C18.072 19.05 17.442 19.1 17.022 18.76C16.612 18.42 16.532 17.81 16.872 17.38C16.982 17.24 18.012 16 20.252 16C22.492 16 24.252 17.32 24.252 19C24.252 20.87 22.322 21.72 20.612 22.47C19.672 22.88 18.252 23.5 18.252 24C18.252 24.31 18.682 24.6 19.322 24.86L17.832 26.35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountOperationIcon);
export default __webpack_public_path__ + "static/media/account_operation_icon.8c2c476c7d3b0e4ec64170af58c96fdd.svg";
export { ForwardRef as ReactComponent };